import {
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import HealingIcon from "@mui/icons-material/Healing";

function MedicinalImportance({ plant }) {
  if (!plant?.medicinal_importance) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 5,
        p: {
          xs: 3,
          md: 4,
        },
        borderRadius: 5,
        background:
          "linear-gradient(135deg,#FFFFFF,#F8FBFC)",
        border: "1px solid #E4EDF2",
        boxShadow: "0 10px 30px rgba(11,60,93,.08)",
      }}
    >
      {/* Heading */}

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        mb={3}
      >
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: "50%",
            bgcolor: "#EEF5FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LocalHospitalIcon
            sx={{
              color: "#0B3C5D",
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            Medicinal Importance
          </Typography>

          <Typography
            color="text.secondary"
            fontSize={15}
          >
            Traditional medicinal applications and documented therapeutic properties
          </Typography>
        </Box>
      </Stack>

      {/* Green Accent */}

      <Box
        sx={{
          width: 90,
          height: 4,
          bgcolor: "#43A047",
          borderRadius: 10,
          mb: 3,
        }}
      />

      {/* Content */}

      <Typography
        sx={{
          textAlign: "justify",
          lineHeight: 2.1,
          color: "#555",
          fontSize: {
            xs: "1rem",
            md: "1.05rem",
          },
        }}
      >
        {plant.medicinal_importance}
      </Typography>

      {/* Educational Note */}

      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 4,

          bgcolor: "#F5FAF7",

          borderLeft: "5px solid #43A047",

          display: "flex",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        <HealingIcon
          sx={{
            color: "#2E7D32",
            mt: 0.3,
          }}
        />

        <Typography
          sx={{
            color: "#555",
            lineHeight: 1.9,
          }}
        >
          <strong style={{ color: "#0B3C5D" }}>
            Educational Note:
          </strong>{" "}
          The medicinal uses described above are based on
          published scientific literature and traditional
          ethnobotanical knowledge. They are provided solely
          for educational and research purposes and should
          not be considered a substitute for professional
          medical diagnosis, treatment, or advice.
        </Typography>
      </Box>
    </Paper>
  );
}

export default MedicinalImportance;